import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";
import {
  BottomSheet,
  BottomSheetIllustrationContent,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";

interface VideoUploadErrorBottomSheetProps {
  modalState: UseModalState;
  errorText: string | undefined;
  canRetryUpload: boolean;
  isLoading: boolean;
  onRetry: () => Promise<void>;
  onClose: () => void;
}

export const TimeclockUploadErrors = {
  InvalidVideo: "There was an error with the video. Please try again.",
  PresignedUrlError: "There was an error preparing the video upload. Please try again.",
  UploadError: "There was an error uploading the video. Please try again.",
  UnknownError: "There was an unknown error. Please try again.",
};

export function VideoUploadErrorBottomSheet(props: VideoUploadErrorBottomSheetProps) {
  const { modalState, errorText, isLoading, onRetry, canRetryUpload, onClose } = props;

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical" onClose={onClose}>
          <LoadingButton
            fullWidth
            variant="contained"
            size="large"
            isLoading={isLoading}
            disabled={isLoading}
            onClick={async () => {
              await onRetry();
            }}
          >
            Retry{canRetryUpload ? " upload" : ""}
          </LoadingButton>
          <Button fullWidth variant="outlined" size="large" onClick={onClose}>
            Cancel
          </Button>
        </DialogFooter>
      }
    >
      <BottomSheetIllustrationContent
        illustrationType="error"
        title="Error submitting video"
        description={errorText ?? TimeclockUploadErrors.UnknownError}
      />
    </BottomSheet>
  );
}
